module.exports = __webpack_public_path__ + "img/wxshare-bg.7b49a108.png";